import { Component, EventEmitter, OnInit, Output, QueryList, ViewChildren, Input } from '@angular/core';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { ConstantsService } from '../../../../services/constants/constants.service';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';


@Component({
  selector: 'app-background-check-list',
  templateUrl: './background-check-list.component.pug',
  styleUrls: ['./background-check-list.component.scss'],
  standalone: false
})
export class BackgroundCheckListComponent implements OnInit {
  @ViewChildren('nestedDropdown') dropdowns!: QueryList<BsDropdownDirective>;
  @Input() alreadySelectedChecksList: any = [];
  @Input() alreadySelectedFlow: any = {};
  @Input() alreadySelectedFlows: any[] = [];
  @Input() backgroundChecksList: any = [];
  @Input() searchValue: any = "";
  @Output() backgroundChecks = new EventEmitter();
  @Output() flow = new EventEmitter();
  selectedBackgroundChecks: any = {};
  flowSelected = 0;
  flowName = '';

  flowSelections: any[] = [];

  trust1101Centric = false;

  // Under Centric, Credential & Education checks no longer expose a flow
  // (Highest level vs Specific quantity) selection on hover - TRUST-1175.
  centricNoFlowChecks = [ConstantsService.CV_SHORT_NAME, ConstantsService.EDUV_SHORT_NAME];

  constructor(private permissionService: PermissionsService) {}

  ngOnInit(): void {
    this.trust1101Centric = this.permissionService.isFeatureActivated('trust-1101-centric');
    if (this.alreadySelectedChecksList && this.alreadySelectedChecksList.length){
      this.selectedBackgroundChecks = this.alreadySelectedChecksList.reduce((acc, obj) => {
        acc[obj.uid] = obj;
        return acc
      }, {});
    }

    if(this.alreadySelectedFlows){
      this.flowSelections = this.alreadySelectedFlows;
    }
    else{
      if (this.alreadySelectedFlow){
        this.flowSelected = this.alreadySelectedFlow.uid;
        this.flowName = this.alreadySelectedFlow.name;
      }
    }
  }

  closeSubDropdown() {
    this.dropdowns.forEach((dropdown, index) => {
      if (dropdown.isOpen) dropdown.hide();
    });
  }

  selectBackgroundCheck(checkSelected, check) {
    // checkSelected will either be true or false, denoting a checkbox selection
    if (!checkSelected) delete this.selectedBackgroundChecks[check.uid]
    else this.selectedBackgroundChecks[check.uid] = check

    // Centric Credential/Education: no flow selection — don't auto-pick the first
    // flow (e.g. "Specific quantity"), which would otherwise show in the label.
    const shouldAutoSelectFlow = checkSelected
      && check.flow_names?.length > 0
      && !(this.trust1101Centric && this.centricNoFlowChecks.includes(check.short_name));

    if (shouldAutoSelectFlow) {

      const existingIndex = this.flowSelections.findIndex(
        sel => sel.parent_short === check.short_name
      );

      if (existingIndex !== -1) {
        // Update existing entry
        this.flowSelections[existingIndex] = {
          id: check.flow_names[0].uid,
          name: check.flow_names[0].name,
          short_name: check.flow_names[0].short_name,
          parent_short: check.short_name
        };
      } else {
        // Add new entry
        this.flowSelections.push({
          id: check.flow_names[0].uid,
          name: check.flow_names[0].name,
          short_name: check.flow_names[0].short_name,
          parent_short: check.short_name
        });
      }
        this.flow.emit(this.flowSelections);

    } else {
        this.flowSelections = this.flowSelections.filter(
          sel => sel.parent_short !== check.short_name
        );
        this.flow.emit(this.flowSelections);
    }
    this.backgroundChecks.emit(Object.values(this.selectedBackgroundChecks))
  }

  selectedFlow(flow, check) {
    // flow here is the child check for mobile id checks, id_doc_one etc.
    // check is the parent check, i.e mobile_id
      const existingIndex = this.flowSelections.findIndex(
        sel => sel.parent_short === check.short_name
      );

      if (existingIndex !== -1) {
        // Update existing entry
        this.flowSelections[existingIndex] = {
          id: flow.uid,
          name: flow.name,
          short_name: flow.short_name,
          parent_short: check.short_name
        };
      } else {
        // Add new entry
        this.flowSelections.push({
          id: flow.uid,
          name: flow.name,
          short_name: flow.short_name,
          parent_short: check.short_name
        });
      }

      this.selectedBackgroundChecks[check.uid] = check;
      this.backgroundChecks.emit(Object.values(this.selectedBackgroundChecks))

      this.flow.emit(this.flowSelections);

  }

  formatData(categories: string[]): string {
    return categories.join(', ');
  }

  getSelectedCheckIds(){
    return Object.keys(this.selectedBackgroundChecks)
  }

  isFlowSelected(flowId: string): boolean {
    return this.flowSelections.some(sel => sel.id === flowId);
  }

  getSelectedFlowName(flowId: string): string | null {
    const match = this.flowSelections.find(f => f.parent_short === flowId);
    return match ? match.name : null;
  }

  showFlowControls(check: any): boolean {
    if (!check.flow_names?.length) {
      return false;
    }
    if (this.trust1101Centric && this.centricNoFlowChecks.includes(check.short_name)) {
      return false;
    }
    return true;
  }
}
